<template>
<div class="login">
  <div class="form">
    <div class="header">
      <b>{{ $t('login.password_reset.heading')}}</b>
    </div>
    <div class="body">
      <p class="helper">{{ $t('login.password_reset.sent_info')}}</p>
      <p class="text-center"><a href="#">{{ this.$route.query.email }}</a></p>
    </div>
    <div class="footer">
      <router-link :to="{ name: 'Login'}" tag="a">
        <i class="fa fa-arrow-left fa-fw" aria-hidden="true"></i>{{ $t('login.back')}}</a>
      </router-link>
    </div>
  </div>
</div>
</template>

<script>
export default {
  created () {
    this.$Progress.finish()
  }
}
</script>
<style scoped lang="stylus" src="../styles/_Login.styl"/>



// WEBPACK FOOTER //
// src/components/PassResetSent.vue